import { extend } from 'vee-validate';
import TeacherService from '@/services/TeacherService';

extend('teacher_id_unique', {
  validate: (id) => {
    return TeacherService.validateId(id)
      .then((response) => {
        return {
          valid: response.data.isValid,
        };
      })
      .catch(() => {
        return {
          valid: false,
        };
      });
  },
});
